import GoalListPageContainer from './containers/GoalListPageContainer'

export default GoalListPageContainer
